import {
    Avatar,
    Box,
    Chip,
    Grid,
    IconButton, InputAdornment, LinearProgress, ListItem, ListItemIcon, ListItemText,
    TextField,
    Typography
} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import PlaceIcon from '@mui/icons-material/Place';

import {FormContainer, TextFieldElement, ToggleButtonGroupElement} from "react-hook-form-mui";
import {useEffect, useRef, useState} from "react";
import {stringToColor} from "../../helpers/functions";
import {useDispatch, useSelector} from "react-redux";
import {FAILURE, FETCHING, SUCCESS} from "../../actions/app-state-action";
import ErrorMessage from "../compents/error-message";
import {fetchInvite, responseInvite} from "../../actions/invite-action";
import {useNavigate, useParams} from "react-router-dom";
import Moment from "react-moment";
import SubmitButton from "../compents/submit-button";

export default function InviteResponse() {
    let {id} = useParams();
    const [items, setItems] = useState([]);
    const [isAccept, setAccept] = useState(false);

    const itemTextRef = useRef();

    const dispatch = useDispatch();

    const {state, message} = useSelector(state => state.appState);
    const invite = useSelector(state => state.invite);

    const navigate = useNavigate();

    const handleDeleteItem = (index) => {
        let itemCpy = [...items];
        itemCpy.splice(index, 1);
        setItems(itemCpy);
    }

    const handleAddItem = () => {
        let val = itemTextRef.current.value;
        if (!val.length) return;
        let itemCpy = [...items];
        itemCpy.push(val)
        setItems(itemCpy);
        itemTextRef.current.value = null;
    }

    const handleSubmit = (data) => {
        data['items'] = items;
        dispatch(responseInvite(data, id));
    }

    useEffect(() => {
        dispatch(fetchInvite(id))
    }, [id]);

    useEffect(() => {
        if (state === SUCCESS) {
            navigate('/success');
        }

        if (state === FAILURE && message === 'no-doc') {
            navigate('/not-found');
        }
    }, [state]);

    if (!invite || state === FETCHING) return <LinearProgress/>

    return (
        <>
            <Box
                sx={style.header}>

                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center">

                    <Grid item>
                        <Typography variant="h1" sx={style.textWhite}>
                            <Moment format="DD">
                                {invite.dateTime}
                            </Moment>
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Typography variant="h4" sx={style.textWhite}>
                            <Moment format="MMMM, YYYY">
                                {invite.dateTime}
                            </Moment>
                        </Typography>
                    </Grid>

                </Grid>
            </Box>

            <Box sx={style.container}>
                <Grid
                    container
                    spacing={2}
                    direction="column"
                    justifyContent="center"
                    alignItems="center">

                    <Grid item>
                        <Typography variant="h3">
                            {invite.title}
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Typography variant="body1" gutterBottom>
                            {invite.description}
                        </Typography>
                    </Grid>

                </Grid>

                <Grid item container>

                    <Grid item sm={4}>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <CheckIcon/>
                            </ListItemIcon>
                            <ListItemText
                                primary="Event Type:"
                                secondary={<Chip label={invite.type}/>}
                            />
                        </ListItem>
                    </Grid>

                    <Grid item sm={4}>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <PlaceIcon/>
                            </ListItemIcon>
                            <ListItemText
                                primary="Venue"
                                secondary={invite.venue}
                            />
                        </ListItem>
                    </Grid>

                    <Grid item sm={4}>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <Avatar
                                    alt={invite.createdBy.displayName}
                                    src={invite.createdBy.photoURL}
                                    sx={{bgcolor: stringToColor(invite.createdBy.displayName)}}/>
                            </ListItemIcon>
                            <ListItemText
                                primary="Organize by:"
                                secondary={invite.createdBy.displayName}
                            />
                        </ListItem>
                    </Grid>

                </Grid>

                <FormContainer
                    onSuccess={handleSubmit}>
                    <Grid container spacing={2}>

                        <Grid item xs={12}>
                            <TextFieldElement name={'fullName'} label={'Full Name'} required fullWidth/>
                        </Grid>

                        <Grid item xs={12}>
                            <TextFieldElement name={'email'} label={'Email'} required type={'email'} fullWidth/>
                        </Grid>

                        <Grid item={12}>
                            <ToggleButtonGroupElement
                                onChange={({target: {value}}) => {
                                    setAccept(value === "accept");
                                }}
                                required
                                exclusive
                                name="response"
                                label={"Your response"}
                                options={[
                                    {
                                        id: 'accept',
                                        label: 'Accept'
                                    },
                                    {
                                        id: 'reject',
                                        label: 'Reject'
                                    },
                                ]}
                            />
                        </Grid>

                        {(isAccept && invite.isPotluck) && <Grid item xs={12}>
                            <TextField
                                inputRef={itemTextRef}
                                label="Item"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">
                                        <IconButton onClick={handleAddItem}>
                                            <AddIcon/>
                                        </IconButton>
                                    </InputAdornment>,
                                }}
                            />
                        </Grid>}

                        {(isAccept && invite.isPotluck) && <Grid item xs={12}>
                            {
                                items.map((item, index) => {
                                    return (
                                        <Chip key={index}
                                              label={item}
                                              variant="outlined"
                                              sx={{margin: 1}}
                                              onDelete={() => handleDeleteItem(index)}/>
                                    )
                                })
                            }
                        </Grid>}

                        <ErrorMessage/>

                        <Grid item xs={12}>
                            <SubmitButton
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{mt: 3, mb: 2}}
                            >
                                SUBMIT
                            </SubmitButton>
                        </Grid>

                    </Grid>

                </FormContainer>
            </Box>
        </>
    );
}

const style = {
    header: {
        padding: 0,
        margin: 0,
        width: '100%',
        height: '25vh',
        backgroundColor: 'primary.main',
    },
    container: {
        marginX: 5,
        marginY:2
    },
    textWhite: {
        color: '#fff'
    }
}